import * as t from "react";
import { c as e } from "../createReactComponent-58f9bea8.mjs";
import { a as s, r as o } from "../rich-input-suggestion-ae5d08aa.mjs";
import { R as u } from "../rich-input-suggestion-ae5d08aa.mjs";
import "../property-9daa16cd.mjs";
import "../_commonjsHelpers-10dfc225.mjs";
const m = e({ tagName: "ex-rich-input-suggestion", elementClass: s, react: t, events: {}, displayName: "ExRichInputSuggestion", registerWebComponent: o });
export {
  m as ExRichInputSuggestion,
  u as RichInputSuggestionType,
  o as register
};
